import { getStorage } from 'storage/storage';

export const _storeViewConfig = (vc) => {
    getStorage().setItem('viewconfig', JSON.stringify(vc));
};
